import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import React from 'react'
import { n_common, n_private_slot } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

interface IHandshakeSlotExpiredModal {
  tutorName: string
  onClose: () => void
  onGoToCheck: () => void
}

const HandshakeSlotExpiredModal: React.FC<IHandshakeSlotExpiredModal> = ({ tutorName, onClose, onGoToCheck }) => {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-[1001] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-[12px] px-[20px] py-[24px] flex flex-col gap-[24px] max-w-[328px] w-full mx-[24px]">
        {/* Title & Body */}
        <div className="flex flex-col gap-[4px]">
          <h2 className="Title2-18Bd text-black">{t(n_private_slot.modal.error_title)}</h2>
          <p className="Body2-14Md text-gray-700">{t(n_private_slot.modal.error_subtitle(tutorName))}</p>
        </div>

        {/* Buttons */}
        <div className="flex gap-[8px]">
          <DSButton
            type={BUTTON_TYPE.OUTLINE}
            size={BUTTON_SIZE.MD}
            onClick={onClose}
            className="flex-1"
            customBorderColor={COLORS.GRAY300}
          >
            <DSButton.Label className="Body2-14Bd text-black">{t(n_common.close)}</DSButton.Label>
          </DSButton>
          <DSButton
            type={BUTTON_TYPE.SOLID}
            size={BUTTON_SIZE.MD}
            customBgColor={COLORS.PURPLE600}
            onClick={onGoToCheck}
            className="flex-1"
          >
            <DSButton.Label className="Body2-14Bd">{t(n_common.go_to_check)}</DSButton.Label>
          </DSButton>
        </div>
      </div>
    </div>
  )
}

export default HandshakeSlotExpiredModal
